import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../common/utils/bongo';

export type Integration = {
  name: string;
  tenant: number;
  full_pull: {
    active: boolean;
  };
  credentials?: any;
  using_mdi?: boolean;
};

export function useIntegrationQuery({
  tenant,
  integration,
}: {
  tenant: number;
  integration: string;
}) {
  return useQuery({
    queryKey: [tenant, 'integrations', integration],
    queryFn: async () => {
      const { data } = await axios.get<Integration>(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/${integration}`
      );

      return data;
    },
  });
}
